export const LOCATION_GROUP_CONSTRAINTS = {
    name: { maxLength: 30, label: 'Warehouse name' },
    id: { label: 'Warehouse' },
};
export const MAX_LOCATION_GROUP_LOCATIONS = 500;
export const MAX_LOCATION_GROUP_LOCATIONS_MESSAGE = `A warehouse can have at most ${MAX_LOCATION_GROUP_LOCATIONS} locations.`;
//# sourceMappingURL=constraints.js.map